module.exports = __webpack_public_path__ + "img/sousuo.5d507f40.png";